import { ModalsManager } from '@/components/modals/modalsManager';
import { MCPAddServerModal } from '@/features/mcp/MCPAddServerModal';
import { RegionSelectModal } from '@/integrations/custom/region-select-modal';

import { DATADOG_SITE_OPTIONS, isDatadogMcpUrl } from './sites';

import type { GuidedCustomMcpOffer } from '../guided-custom-mcp';

const DATADOG_MCP_DISPLAY_NAME = 'Datadog';

async function connectDatadog(): Promise<void> {
  const mcpUrl = await ModalsManager.showResolvable(RegionSelectModal, {
    title: 'Datadog site',
    description: 'Choose the Datadog site your organization uses.',
    options: DATADOG_SITE_OPTIONS,
  });
  if (!mcpUrl) return;

  ModalsManager.show(MCPAddServerModal, {
    initialName: DATADOG_MCP_DISPLAY_NAME,
    initialUrl: mcpUrl,
  });
}

export const datadogOffer: GuidedCustomMcpOffer = {
  id: 'datadog',
  name: DATADOG_MCP_DISPLAY_NAME,
  description:
    'Search Datadog logs, metrics, traces, monitors, incidents, and dashboards.',
  icon: 'datadog',
  categories: ['dev_tools'],
  searchText: 'datadog observability logs metrics apm traces monitors mcp',
  isConnected: (servers) =>
    servers.some((server) => isDatadogMcpUrl(server.url)),
  connect: connectDatadog,
};
